import { CustomCell } from '@shared/modules/data-table/classes/CustomCell';

export enum CustomCellType {
  Default = 'default',
}

export interface CustomCellConfig<T> {
  [key: string]: CustomCell<T>;
}
